export const  serviceModules = {
  TRAVEL: '5c74ed2177addf3b07acb011',
  EXPENSE: '5c74ed2977addf3b07acb012',
  CASH_ADMIN: '5c74ed3677addf3b07acb013',
  COMPANY: '5c74ed3d77addf3b07acb014'

}